/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5A.75.75 0 0 0 12 0C5.3726 0 0 5.3726 0 12s5.3726 12 12 12 12-5.3726 12-12a.75.75 0 0 0-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12Zm17.3808-9.3557L15.932 5.5931v2.475h2.4749l2.9488-2.9489h-2.4749V2.6443Zm-4.4488 5.863V4.9719l.2197-.2196L19.0152.3887c.5039-.504 1.3656-.147 1.3656.5657v2.6648h2.6649c.7127 0 1.0696.8617.5656 1.3657l-4.3635 4.3635-.2196.2196H15.4926l-2.9623 2.9623a.75.75 0 0 1-1.0606 0 .75.75 0 0 1 0-1.0606l2.9623-2.9623ZM12 6.75c-2.8995 0-5.25 2.3505-5.25 5.25s2.3505 5.25 5.25 5.25 5.25-2.3505 5.25-5.25a.75.75 0 0 1 1.5 0c0 3.7279-3.0221 6.75-6.75 6.75-3.728 0-6.75-3.0221-6.75-6.75 0-3.728 3.022-6.75 6.75-6.75a.75.75 0 0 1 0 1.5Z"
    clipRule="evenodd"
  />,
  'MenuOperationalInsights'
);
